export const getFilters = s => s.people.get('filters')?.toJS();
export const getPeoples = s => s.people.get('peoples').toJS();
export const getPeoplesLoading = s => s.people.get('peoplesLoading');
